import { render, staticRenderFns } from "./ClearOrdersModal.vue?vue&type=template&id=526710eb&scoped=true"
import script from "./ClearOrdersModal.vue?vue&type=script&lang=js"
export * from "./ClearOrdersModal.vue?vue&type=script&lang=js"
import style0 from "./ClearOrdersModal.vue?vue&type=style&index=0&id=526710eb&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526710eb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1465996501/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('526710eb')) {
      api.createRecord('526710eb', component.options)
    } else {
      api.reload('526710eb', component.options)
    }
    module.hot.accept("./ClearOrdersModal.vue?vue&type=template&id=526710eb&scoped=true", function () {
      api.rerender('526710eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ClearOrdersModal.vue"
export default component.exports